import { Component, ViewChild, ElementRef } from '@angular/core';
import { AppSpinner } from './appSpinner.model';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {

  @ViewChild('spinnerDiv') spinnerDiv: ElementRef;

  spinner: AppSpinner;

  constructor() { }

}
